// eslint-disable-next-line no-restricted-imports
import { LoginModel, LoginResponse } from 'types';
import genericNormalizer from './generic';

export const normalizeLogin = genericNormalizer<LoginResponse, LoginModel>(
  ({ from }) => ({
    email: from('email'),
    id: from('id'),
    primary: from('primary'),
  }),
);



// WEBPACK FOOTER //
// ./app/gamma/src/api/normalizers/login.ts